import { render, staticRenderFns } from "./prevideo.vue?vue&type=template&id=096a0f8e"
import script from "./prevideo.vue?vue&type=script&lang=js"
export * from "./prevideo.vue?vue&type=script&lang=js"
import style0 from "./prevideo.vue?vue&type=style&index=0&id=096a0f8e&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports